module.exports = __webpack_public_path__ + "static/media/credit-card-logos.f4ec4a49.png";